import {
  ADD_QUIZZ_ANSWER,
  ADD_QUIZZ_ANSWER_SUCCESS,
  ADD_QUIZZ_ANSWER_CLEAN,
  ADD_QUIZZ_ANSWER_ERROR,
} from "./actionTypes"

export const addQuizzAnswer = form => ({
  type: ADD_QUIZZ_ANSWER,
  payload: { form },
})

export const addQuizzAnswerSuccess = answer => {
  return {
    type: ADD_QUIZZ_ANSWER_SUCCESS,
    payload: { answer },
  }
}

export const addQuizzAnswerClean = () => {
  return {
    type: ADD_QUIZZ_ANSWER_CLEAN,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: ADD_QUIZZ_ANSWER_ERROR,
    payload: error,
  }
}
